import keycloak from "Keycloak"

export default function Signup(params) {
    keycloak.register()
    return(<></>)
};
